import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyGetPolls = () => {
  const createResource = useCallback(
    ({ assignmentId, pollId, shouldFetchTemplates, skip }) => {
      if (skip || (!shouldFetchTemplates && !assignmentId && !pollId))
        return undefined;

      const params = {
        ...(assignmentId && { assignment_id: assignmentId }),
        ...(shouldFetchTemplates && { is_template: 1 }),
      };

      const queryString = new URLSearchParams(params).toString();
      return `${API_BASE_URL}/api/v3/activity/${pollId ? `${pollId}/` : ""}?${queryString}`;
    },
    [],
  );
  return useLazyRestQuery(createResource);
};

export default useLazyGetPolls;
